import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material'; 
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import useUser from './hooks/useUser';

const NavBar = () => {
    const { user } = useUser()
    const navigate = useNavigate();
    return(
        <AppBar position="fixed" color="default" elevation={1}>
            <Toolbar sx={{ justifyContent: 'space-between' }}>
                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button component={Link} to="/" color="inherit">Home</Button>
                    {/* <Button component={Link} to="/about" color="inherit">About</Button> */}
                    {/* <Button component={Link} to="/articles" color="inherit">Articles</Button> */}
                    <Button component={Link} to="/tools" color="inherit">Tools</Button>
                    {/* <Button component={Link} to="/forgot-password" color="inherit">Reset</Button> */}
                </Box>
                <Box>
                {user ? (
                    <Button color="primary" variant="outlined" onClick={() => signOut(getAuth())}>
                    Log Out
                    </Button>
                ) : (
                    <Button color="primary" variant="contained" onClick={() => navigate('/login')}>
                    Log In
                    </Button>
                )}
                </Box>
            </Toolbar>
        </AppBar>
    )
}

export default NavBar;